(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Slider-produit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.wmReady) return;
      root.dataset.wmReady = 'true';

      var track = root.querySelector('[data-wm-track]');
      var prev = root.querySelector('[data-wm-prev]');
      var next = root.querySelector('[data-wm-next]');
      var dotsWrap = root.querySelector('[data-wm-dots]');
      var controls = root.querySelector('[data-wm-controls]');
      if (!track) return;

      var cards = Array.prototype.slice.call(track.children).filter(function (el) {
        return el.classList.contains('wm-card');
      });
      var dots = [];

      function step() {
        if (cards.length < 2) return track.clientWidth;
        return cards[1].offsetLeft - cards[0].offsetLeft || track.clientWidth;
      }

      function maxIndex() {
        return Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / step()));
      }

      function goTo(i) {
        track.scrollTo({ left: i * step(), behavior: 'smooth' });
      }

      function buildDots() {
        var count = maxIndex() + 1;
        dotsWrap.innerHTML = '';
        dots = [];
        controls.hidden = count <= 1;
        for (var i = 0; i < count; i++) {
          (function (index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'wm-dot';
            dot.setAttribute('aria-label', 'Aller à la position ' + (index + 1));
            dot.addEventListener('click', function () { goTo(index); });
            dotsWrap.appendChild(dot);
            dots.push(dot);
          })(i);
        }
        update();
      }

      function update() {
        var last = maxIndex();
        var index = Math.min(last, Math.max(0, Math.round(track.scrollLeft / step())));
        var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        if (atEnd) index = last;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = atEnd;
        dots.forEach(function (dot, i) {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { update(); ticking = false; });
      }, { passive: true });

      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      if ('ResizeObserver' in window) {
        new ResizeObserver(buildDots).observe(track);
      } else {
        window.addEventListener('resize', buildDots);
      }
      buildDots();

      /* ---------- Ajout au panier (1 pot) ----------
         Même mécanisme que le sélecteur de packs des fiches produit :
         on demande à Shopify le nouveau HTML du panier latéral (<cart-drawer>),
         on remplace l'ancien et on l'ouvre, pour qu'il affiche l'ajout tout de suite. */
      root.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-wm-add]');
        if (!btn || btn.disabled) return;

        var label = btn.querySelector('.wm-btn__label');
        var original = label.textContent;
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        function reset() {
          label.textContent = original;
          btn.classList.remove('is-added');
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        }

        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');

        var existingDrawer = document.querySelector('cart-drawer');
        var sectionId = existingDrawer ? existingDrawer.dataset.sectionId : null;

        var payload = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };
        if (sectionId) payload.sections = sectionId;

        fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart');
            return res.json();
          })
          .then(function (data) {
            btn.removeAttribute('aria-busy');
            btn.classList.add('is-added');
            label.textContent = btn.dataset.addedLabel;
            setTimeout(reset, 1600);

            if (sectionId && data.sections && data.sections[sectionId]) {
              var doc = new DOMParser().parseFromString(data.sections[sectionId], 'text/html');
              var newDrawer = doc.querySelector('cart-drawer');
              var oldDrawer = document.querySelector('cart-drawer');
              if (newDrawer && oldDrawer) {
                oldDrawer.replaceWith(newDrawer);
                requestAnimationFrame(function () { newDrawer.classList.add('is-open'); });
                return;
              }
            }

            var fallbackDrawer = document.querySelector('cart-drawer');
            if (fallbackDrawer) {
              fallbackDrawer.classList.add('is-open');
            } else {
              window.location.href = base + 'cart';
            }
          })
          .catch(function () {
            btn.removeAttribute('aria-busy');
            label.textContent = btn.dataset.errorLabel;
            setTimeout(reset, 2200);
          });
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-wm-slider]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Slider-produits-simple"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.wmReady) return;
      root.dataset.wmReady = 'true';

      var track = root.querySelector('[data-wm-track]');
      var prev = root.querySelector('[data-wm-prev]');
      var next = root.querySelector('[data-wm-next]');
      var arrows = root.querySelector('[data-wm-arrows]');
      var dotsWrap = root.querySelector('[data-wm-dots]');
      if (!track) return;

      var cards = Array.prototype.slice.call(track.children).filter(function (el) {
        return el.classList.contains('wm-card');
      });
      var dots = [];

      function step() {
        if (cards.length < 2) return track.clientWidth;
        return cards[1].offsetLeft - cards[0].offsetLeft || track.clientWidth;
      }

      function maxIndex() {
        return Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / step()));
      }

      function goTo(i) {
        track.scrollTo({ left: i * step(), behavior: 'smooth' });
      }

      function buildDots() {
        var count = maxIndex() + 1;
        dotsWrap.innerHTML = '';
        dots = [];
        arrows.hidden = count <= 1;
        dotsWrap.hidden = count <= 1;
        for (var i = 0; i < count; i++) {
          (function (index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'wm-dot';
            dot.setAttribute('aria-label', 'Aller à la position ' + (index + 1));
            dot.addEventListener('click', function () { goTo(index); });
            dotsWrap.appendChild(dot);
            dots.push(dot);
          })(i);
        }
        update();
      }

      function update() {
        var last = maxIndex();
        var index = Math.min(last, Math.max(0, Math.round(track.scrollLeft / step())));
        var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        if (atEnd) index = last;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = atEnd;
        dots.forEach(function (dot, i) {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { update(); ticking = false; });
      }, { passive: true });

      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      if ('ResizeObserver' in window) {
        new ResizeObserver(buildDots).observe(track);
      } else {
        window.addEventListener('resize', buildDots);
      }
      buildDots();

      /* ---------- Ajout au panier (1 pot) ----------
         On demande à Shopify le nouveau HTML du panier latéral (<cart-drawer>),
         on remplace l'ancien et on l'ouvre. */
      root.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-wm-add]');
        if (!btn || btn.disabled) return;

        var label = btn.querySelector('.wm-btn__label');
        var original = label.textContent;
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        function reset() {
          label.textContent = original;
          btn.classList.remove('is-added');
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        }

        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');

        var existingDrawer = document.querySelector('cart-drawer');
        var sectionId = existingDrawer ? existingDrawer.dataset.sectionId : null;

        var payload = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };
        if (sectionId) payload.sections = sectionId;

        fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart');
            return res.json();
          })
          .then(function (data) {
            btn.removeAttribute('aria-busy');
            btn.classList.add('is-added');
            label.textContent = btn.dataset.addedLabel;
            setTimeout(reset, 1600);

            if (sectionId && data.sections && data.sections[sectionId]) {
              var doc = new DOMParser().parseFromString(data.sections[sectionId], 'text/html');
              var newDrawer = doc.querySelector('cart-drawer');
              var oldDrawer = document.querySelector('cart-drawer');
              if (newDrawer && oldDrawer) {
                oldDrawer.replaceWith(newDrawer);
                requestAnimationFrame(function () { newDrawer.classList.add('is-open'); });
                return;
              }
            }

            var fallbackDrawer = document.querySelector('cart-drawer');
            if (fallbackDrawer) {
              fallbackDrawer.classList.add('is-open');
            } else {
              window.location.href = base + 'cart';
            }
          })
          .catch(function () {
            btn.removeAttribute('aria-busy');
            label.textContent = btn.dataset.errorLabel;
            setTimeout(reset, 2200);
          });
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-wm-slider]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Wouf-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.wmReady) return;
      root.dataset.wmReady = 'true';

      /* Après inscription, la page se recharge : on ramène la vue sur le code. */
      var success = root.querySelector('[data-wm-success]');
      if (success) {
        root.scrollIntoView({ block: 'center' });
        success.focus({ preventScroll: true });
      }

      var copyBtn = root.querySelector('[data-wm-copy]');
      if (!copyBtn) return;
      copyBtn.addEventListener('click', function () {
        var code = root.querySelector('[data-wm-code]').textContent.trim();
        var label = copyBtn.querySelector('[data-wm-copy-label]');
        var done = function () {
          label.textContent = copyBtn.dataset.copied;
          copyBtn.classList.add('is-copied');
          setTimeout(function () {
            label.textContent = 'Copier';
            copyBtn.classList.remove('is-copied');
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(fallback);
        } else {
          fallback();
        }
        function fallback() {
          var t = document.createElement('textarea');
          t.value = code;
          t.setAttribute('readonly', '');
          t.style.position = 'fixed';
          t.style.opacity = '0';
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          document.body.removeChild(t);
        }
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-wm-news]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
